import {Card} from 'shells/card/card';
import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import type {LocationWeatherFragment} from 'nutshell-graphql-types';

import {getWeatherIllustrationSrc} from './helpers';

import styles from './peep-map.module.css';

interface Props {
    weather: LocationWeatherFragment;
}

export function WeatherOverlay(props: Props) {
    const illustrationSrc = getWeatherIllustrationSrc(props.weather);

    return (
        <div className={styles['weather']}>
            <Card
                hasBorder={true}
                hasShadow={false}
                borderRadius={8}
                fitContent={false}
                fitHeight={false}
            >
                <div className='py-12 px-16'>
                    <Stack isHorizontal={true} alignItems='center' spacing={16}>
                        <Illustration src={illustrationSrc} width={44} height={44} />
                        <div className='min-width-0 flex-grow'>
                            <Stack spacing={4} isFullWidth={true}>
                                <Stack
                                    isHorizontal={true}
                                    alignItems='center'
                                    spacing={4}
                                    justifyContent='space-between'
                                    isFullWidth={true}
                                >
                                    <Body size='large' isBold={true} color='dark'>
                                        {props.weather.temperature}
                                    </Body>
                                    <Body size='large'>{props.weather.localTime}</Body>
                                </Stack>
                                <Body
                                    color='light'
                                    truncate={{type: 'block'}}
                                    title={props.weather.location ?? undefined}
                                >
                                    {props.weather.location}
                                </Body>
                            </Stack>
                        </div>
                    </Stack>
                </div>
            </Card>
        </div>
    );
}
